module.exports = __webpack_public_path__ + "static/img/mynjoi-onboarding-details.4d21a0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/mynjoi-onboarding-details.jpg
// module id = 1TLp
// module chunks = 1